export function parseLocaleNumber(stringNumber: any, locale?: any) {
    var thousandSeparator = Intl.NumberFormat(locale || "en-US")
        .format(11111)
        .replace(/\p{Number}/gu, "");
    var decimalSeparator = Intl.NumberFormat(locale || "en-US")
        .format(1.1)
        .replace(/\p{Number}/gu, "");

    return parseFloat(
        stringNumber.toString().replace(new RegExp("\\" + thousandSeparator, "g"), "")
        // .replace(new RegExp("\\" + decimalSeparator), ".")
    );
}



export function shortenFileName(fileName : string, maxLength:number) {
    if (fileName.length <= maxLength) {
      return fileName;
    }
  
    const extensionIndex = fileName.lastIndexOf('.');
    const name = fileName.substring(0, extensionIndex);
    const extension = fileName.substring(extensionIndex);
    const shortenedName = name.substring(0, maxLength - extension.length);
  
    return shortenedName + '...' + extension;
  }


  export const updateObject = (object: any, key: any, value: any) => {
    // Create a new object with the existing key-value pairs
    const updatedObject = { ...object };

    // Update the specific key-value pair
    updatedObject[key] = value;

    return updatedObject;
  };